import { Deserializable } from '../protocols/deserializable';
import * as moment from 'moment';
import { AnnualMinimumProvenanceType } from './annual-minimum-provenance-type';
import { AnnualMinimumProvenanceTypeIdEnum } from './enum/annual-minimum-provenance-type-id.enum';

export class AnnualMinimumDetails implements Deserializable {
  public id!: string; // GUID
  public effectiveYear!: number;
  public provenanceTypeId!: AnnualMinimumProvenanceTypeIdEnum;
  public provenanceType!: AnnualMinimumProvenanceType;
  public minimumAgeDateOfBirth!: string;
  public minimumAgeName!: string;
  public minimumAgeSpouseId!: number | null;
  public memberDateOfBirth!: string;
  public minimumAnnualWithdrawalAmount!: number;

  // Not From Api
  public formattedDateOfBirth!: string;
  public isSpouse!: boolean;
  public isEstimated!: boolean;

  public onDeserialize(): void {
    if (this.minimumAgeDateOfBirth) {
      this.formattedDateOfBirth = moment(this.minimumAgeDateOfBirth.split('T')[0]).format('MMMM DD, YYYY');
    }

    if (this.provenanceType) {
      this.provenanceType = window?.injector?.Deserialize?.instanceOf(AnnualMinimumProvenanceType, this.provenanceType);
    }

    this.isSpouse = this.minimumAgeSpouseId !== null;
    this.isEstimated = this.provenanceTypeId === AnnualMinimumProvenanceTypeIdEnum.Estimated;
  }
}
